/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

document.addEventListener('DOMContentLoaded', () => {
  const sizeChart = document.querySelector('[data-size-chart]');
  const target = document.querySelector('[data-size-chart-target]');

  if (sizeChart && target) {
    target.appendChild(sizeChart);
    sizeChart.hidden = false;
  }
});


  // Mute button logic
  document.addEventListener("DOMContentLoaded", function () {
    const toggleButtons = document.querySelectorAll('.video-mute-toggle');

    toggleButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const videoId = button.dataset.videoId;
        const video = document.getElementById(videoId);
        
        if (!video) return;
        const isMuted = video.muted;
        video.muted = !isMuted;

        button.classList.toggle('is-muted', video.muted);
      });
    });
  });

  

    // PDP Desc Read more Logic
    document.addEventListener("DOMContentLoaded", function () {
    const readMore = document.getElementById("read-more");
    const readLess = document.getElementById("read-less");
    const truncated = document.getElementById("truncated-description");
    const full = document.getElementById("full-description");

    if (readMore && readLess && truncated && full) {
      readMore.addEventListener("click", function () {
        truncated.style.display = "none";
        full.style.display = "block";
      });

      readLess.addEventListener("click", function () {
        full.style.display = "none";
        truncated.style.display = "block";
      });
    }
  });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
